import { render, staticRenderFns } from "./financeProjectVote.vue?vue&type=template&id=24a38d77&scoped=true&"
import script from "./financeProjectVote.vue?vue&type=script&lang=tsx&"
export * from "./financeProjectVote.vue?vue&type=script&lang=tsx&"
import style0 from "./financeProjectVote.vue?vue&type=style&index=0&id=24a38d77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a38d77",
  null
  
)

export default component.exports